import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { urlApi } from '../../../utils/apiConfig';

@Injectable()
export class ClientsServiceService {


  constructor(private http : HttpClient) {
   
   }


  public getClients(): Observable<any>{
    return this.http.get(urlApi+"/admin/clientes");
  }

  public getClientsInactive(): Observable<any>{
    return this.http.get(urlApi+"/admin/clientes/desativados");
  }

  public getRevendedores(): Observable<any>{
    return this.http.get(urlApi+"/admin/revendedor/list");
  }

  public createClient(data: any): Observable<any>{
    return this.http.post(urlApi+"/admin/clientes/cadastro",data );
  }

  public updateClient(data: any): Observable<any>{
    return this.http.patch(urlApi+"/admin/clientes",data);
  }

  public addOneChannel(client: any, userLevel: string): Observable<any>{
    if(userLevel === '3'){
    return this.http.patch(urlApi+"/admin/clientes/addchannel", {idcliente: client.idcliente});
    }else {
      return this.http.post(urlApi+"/admin/pagarme/addchannel", {
        idCliente: client.idcliente,
        quantidadeCanais: client.quantidadecanais
      });
    }
  }

  public addChannelsWithCredits(payload: { idClient: number; quantidadeCanais: number }): Observable<any> {
    return this.http.patch(urlApi + "/admin/licencas/addchannel/credits", payload);
  }

  public removeOneChannel(client: any, userLevel: string): Observable<any>{
    if(userLevel === '3'){
      return this.http.patch(urlApi+"/admin/clientes/removechannel", {idcliente: client.idcliente});
    }else {
      return this.http.patch(urlApi+"/admin/clientes/removechannel", {idcliente: client.idcliente});
    }
  }

  public addMessagePredefined(client: any){
    return this.http.patch(urlApi+"/admin/configuracoes/addmessage", {idcliente: client.idcliente});
  }

  public removeMessagePredefined(client: any){
    return this.http.patch(urlApi+"/admin/configuracoes/removemessage", {idcliente: client.idcliente});
  }

  public addNutrition(client: any){
    return this.http.patch(urlApi+"/admin/configuracoes/addnutricao", {idcliente: client.idcliente});
  }

  public removeNutrition(client: any){
    return this.http.patch(urlApi+"/admin/configuracoes/removenutricao", {idcliente: client.idcliente});
  }

  public updateOnlyHostClient(client: any){
    return this.http.patch(urlApi+"/admin/update/user/host", client);
  }

  public updateOnlyPasswordClient(client: any){
    return this.http.patch(urlApi+"/admin/update/user/password", client);
  }

  public deleteClient(idClient: number){
    return this.http.delete(urlApi+`/admin/clientes/${idClient}'`);
  }

  public renewClient(idClient: number){
    return this.http.patch(urlApi+`/admin/cliente/reativar`, {idcliente: idClient});
  }

  public handleAgendaMenu(client: any){
    return this.http.patch(urlApi+`/admin/configuracoes/handle-agenda`, {idcliente: client.idcliente});
  }

  public handleClinicorpMenu(client: any){
    return this.http.patch(urlApi+`/admin/configuracoes/handle-clinicorp`, {idcliente: client.idcliente});
  }

}
